import store from "@/store";
import { scrollToEnd, focus, select } from "@/utils/document";

export function handlePowershellEvent(data) {
  if (data.line.status == "end") {
    store.commit("powershell/setStatus", {
      complete: true,
      terminating: false,
    });
  } else if (data.line.status == "noperm") {
    store.commit("powershell/setStatus", {
      complete: true,
      terminating: false,
    });
  }

  store.commit("powershell/addLine", data.line);

  if (data.line.status === "end") {
    scrollToEnd("pre-powershell");
    focus("input-powershell");
    setTimeout(() => select("input-powershell"), 10);
  }
}
